import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { parseEntityLinks, EntityMiniCard } from "@/components/EntityEmbed";
import SpeciesDetailModal from "@/components/marine/SpeciesDetailModal";
import DiveReportModal from "@/components/DiveReportModal";
import axios from "axios";
import { BACKEND_URL } from '@/utils/apiConfig';

const API = `${BACKEND_URL}/api`;

/**
 * Renders text with inline entity embeds.
 * Entity links like [[species:uuid]] are rendered as clickable mini-cards.
 */
const RichContent = ({ text, className = "", isOwnMessage = false, onNavigate }) => {
  const navigate = useNavigate();
  const [selectedSpecies, setSelectedSpecies] = useState(null);
  const [speciesModalOpen, setSpeciesModalOpen] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [reportModalOpen, setReportModalOpen] = useState(false);

  if (!text) return null;

  const parts = parseEntityLinks(text);
  const hasEntities = parts.some(p => p.type === "entity");

  if (!hasEntities) {
    return <span className={className}>{text}</span>;
  }

  const handleEntityClick = async (preview) => {
    if (preview.type === "species") {
      try {
        const res = await axios.get(`${API}/marine-database/${preview.id}`);
        setSelectedSpecies(res.data);
        setSpeciesModalOpen(true);
      } catch {
        onNavigate?.();
        navigate(`/community/marine-database?species=${preview.id}`);
      }
    } else if (preview.type === "report") {
      try {
        const token = localStorage.getItem("token") || sessionStorage.getItem("token");
        const res = await axios.get(`${API}/dive-reports/${preview.id}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {}
        });
        setSelectedReport(res.data);
        setReportModalOpen(true);
      } catch {
        onNavigate?.();
        navigate(`/community`);
      }
    } else if (preview.type === "trip") {
      onNavigate?.();
      navigate(`/community?tab=trips&trip=${preview.id}`);
    } else if (preview.type === "thread") {
      onNavigate?.();
      navigate(`/community/forum/${preview.id}`);
    }
  };

  return (
    <>
      <span className={className}>
        {parts.map((part, idx) => {
          if (part.type === "text") {
            return <span key={idx}>{part.content}</span>;
          }
          return (
            <span key={idx} className="inline-block align-middle my-0.5">
              <EntityMiniCard
                type={part.entityType}
                id={part.entityId}
                onClick={handleEntityClick}
              />
            </span>
          );
        })}
      </span>

      {speciesModalOpen && selectedSpecies && (
        <SpeciesDetailModal
          species={selectedSpecies}
          onClose={() => {
            setSpeciesModalOpen(false);
            setSelectedSpecies(null);
          }}
          canEdit={false}
          onUpdate={() => {}}
        />
      )}

      {reportModalOpen && selectedReport && (
        <DiveReportModal
          report={selectedReport}
          isOpen={reportModalOpen}
          onClose={() => {
            setReportModalOpen(false);
            setSelectedReport(null);
          }}
        />
      )}
    </>
  );
};

export default RichContent;
